exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subheader{margin-top:49px;margin-bottom:40px}.subheader .subheader__exit{cursor:pointer}", ""]);

// exports
